<ngx-spinner bdColor = "rgba(0,0,0,0.5)" size = "medium" color = "#fff" type = "ball-clip-rotate" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>
<div [class.wrapper]="!router.url.includes('login')">
    <app-header *ngIf="!router.url.includes('login')"></app-header>
    <app-navbar *ngIf="!router.url.includes('login')"></app-navbar>
    <div [class.content]="!router.url.includes('login')">
        <router-outlet></router-outlet>
    </div>
</div>